/* VALORE theme behaviour — mobile menu, accordions, variant/size selection. */
(function () {
  "use strict";

  /* ------------------------------------------------------------ menu ---- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-menu-toggle]");
    if (!toggle) return;
    var menu = document.querySelector("[data-mobile-menu]");
    if (!menu) return;
    var open = menu.getAttribute("data-open") !== "true";
    menu.setAttribute("data-open", String(open));
    toggle.setAttribute("aria-expanded", String(open));
    toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    document.body.style.overflow = open ? "hidden" : "";
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-mobile-menu] a")) {
      var menu = document.querySelector("[data-mobile-menu]");
      if (menu) menu.setAttribute("data-open", "false");
      document.body.style.overflow = "";
    }
  });

  /* ------------------------------------------------------- accordions ---- */
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-accordion-trigger]");
    if (!trigger) return;
    var item = trigger.closest(".accordion__item");
    var group = trigger.closest("[data-accordion-single]");
    var willOpen = item.getAttribute("data-open") !== "true";
    if (group && willOpen) {
      group.querySelectorAll(".accordion__item").forEach(function (other) {
        other.setAttribute("data-open", "false");
        var t = other.querySelector("[data-accordion-trigger]");
        if (t) t.setAttribute("aria-expanded", "false");
        var s = other.querySelector(".accordion__sign");
        if (s) s.textContent = "+";
      });
    }
    item.setAttribute("data-open", String(willOpen));
    trigger.setAttribute("aria-expanded", String(willOpen));
    var sign = item.querySelector(".accordion__sign");
    if (sign) sign.textContent = willOpen ? "\u2212" : "+";
  });

  /* ------------------------------------------------- product variants ---- */
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var buttons = form.querySelectorAll("[data-variant-id]");
    var idInput = form.querySelector("[data-variant-input]");
    var submit = form.querySelector("[data-submit]");
    if (!buttons.length) return;

    var addLabel = submit ? submit.getAttribute("data-label-add") : "Add to cart";
    var pickLabel = submit ? submit.getAttribute("data-label-pick") : "Select a size";
    var soldLabel = submit ? submit.getAttribute("data-label-sold") : "Sold out";

    function select(button) {
      buttons.forEach(function (b) {
        b.setAttribute("aria-pressed", String(b === button));
      });
      if (idInput) idInput.value = button.getAttribute("data-variant-id");
      if (submit) {
        var available = button.getAttribute("data-available") === "true";
        submit.disabled = !available;
        submit.textContent = available ? addLabel : soldLabel;
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener("click", function () {
        if (b.disabled) return;
        select(b);
      });
    });

    if (buttons.length === 1) {
      select(buttons[0]);
    } else if (submit) {
      submit.disabled = true;
      submit.textContent = pickLabel;
    }
  });

  /* ------------------------------------------------- scroll reveal ---- */
  var reveals = document.querySelectorAll("[data-reveal]");
  if (reveals.length) {
    if (!("IntersectionObserver" in window)) {
      reveals.forEach(function (el) { el.setAttribute("data-shown", "true"); });
    } else {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            var delay = parseInt(el.getAttribute("data-reveal-delay") || "0", 10);
            el.style.transitionDelay = delay + "ms";
            el.setAttribute("data-shown", "true");
            io.unobserve(el);
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
      );
      reveals.forEach(function (el) { io.observe(el); });
    }
  }
})();
